import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconColorBit = function IconColorBit(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-color-bit"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Intersect",
    d: "M16.9998 6.8522C16.9996 6.13554 16.6152 5.47388 15.9925 5.11816C15.9927 5.11824 15.9924 5.11809 15.9925 5.11816L10.9922 2.26328C10.3773 1.91224 9.62251 1.91224 9.00766 2.26328L4.00771 5.11793C4.0078 5.11788 4.00762 5.11798 4.00771 5.11793C3.38473 5.47374 3 6.13592 3 6.8529V13.5258C3 14.2423 3.384 14.904 4.00633 15.26C4.00679 15.2602 4.00725 15.2605 4.00771 15.2607L9.00766 18.1154C9.00824 18.1157 9.00883 18.1161 9.00942 18.1164C9.6234 18.4661 10.3765 18.4661 10.9905 18.1163C10.9911 18.116 10.9916 18.1157 10.9922 18.1154L15.9921 15.2607C15.9926 15.2605 15.9931 15.2602 15.9936 15.2599C16.6159 14.9039 16.9998 14.2423 16.9998 13.5258L16.9998 6.8522C16.9998 6.85197 16.9998 6.85243 16.9998 6.8522Z",
    fill: "#8153E1"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Intersect_2",
    d: "M17 6.85072V13.5255C17 14.2426 16.6154 14.9047 15.9923 15.2605L10.9923 18.1151C10.6849 18.2906 10.3425 18.3784 10.0001 18.3784V9.68949L16.7288 5.84784C16.9031 6.14736 16.9996 6.49214 17 6.85072Z",
    fill: "#AB88F3"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Intersect_3",
    d: "M16.7266 5.84812L9.99793 9.68978L3.26923 5.84812C3.44322 5.54927 3.69477 5.29546 4.00571 5.11793L9.00566 2.26328C9.62052 1.91224 10.3753 1.91224 10.9902 2.26328L15.9901 5.11793C16.3011 5.29546 16.5526 5.54927 16.7266 5.84812Z",
    fill: "#D4CCF5"
  })));
};

export { IconColorBit };
